import axios from 'axios';

import jwt_decode from 'jwt-decode';
import { ISigma_CuentasAtributtes } from 'src/models/sigma/ISigma_CuentasAtributtes';
import {
  ILoginValues,
  ISigma_Admin_Autorizada,
  ISigma_Cuenta_Autorizada,
  Sigma_Account_Auth
} from 'src/models/sigma/Sigma_Account_Auth';

const urls = process.env.REACT_APP_BACKURL + 'cuenta_auth';
const urlsChangePass =
  process.env.REACT_APP_BACKURL + 'sigma_cuentas/cliente/reset';
const urlsTheMatrix = process.env.REACT_APP_BACKURL + 'cuenta_auth/thematrix';
export const postCuenta_auth = async (params: ILoginValues) => {
  //  return await axios.get("http://localhost:9401/administradoressigma");
  return await axios
    .post<ISigma_Cuenta_Autorizada>(urls, params)
    .then((response) => {
      window.sessionStorage.removeItem('tokenAdmin');
      window.sessionStorage.removeItem('alphaAA');
      window.sessionStorage.setItem('tokenSigma', response.data.authToken);

      var alphaSS = jwt_decode(response.data.authToken) as Sigma_Account_Auth;
      window.sessionStorage.setItem('alphaSS', JSON.stringify(alphaSS));
      return response.data.authToken;
    })
    .catch(function (error) {
      console.log(error);
      if (error.response.status == 404) {
        alert('Usuario y contraseña inválidos');
        return;
      }
    })
    .catch(function (error) {
      console.log(error);

      alert('Error de conexión, comunicarse con soporte');
    });
};

export const postChangePassword = async (params: {
  id;
  OLD_PASS;
  NEW_PASS;
  _user;
}) => {
  const token = sessionStorage.getItem('tokenSigma');
  const dataMeta = window.sessionStorage.getItem('_clientMeta');

  const dataMetaua = window.sessionStorage.getItem('_clientUA');
  const dataMetaav = window.sessionStorage.getItem('_clientAV');
  return await axios
    .post<ISigma_CuentasAtributtes>(urlsChangePass, params, {
      headers: {
        'auth-token': token,
        _clientMeta: dataMeta,
        _clientUA: dataMetaua,
        _clientAV: dataMetaav
      }
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      if (error.response.status == 404) {
        // alert('Usuario y contraseña inválidos');
        return;
      }
    })
    .catch(function (error) {
      console.log(error);

      // alert('Error de conexión, comunicarse con soporte');
    });
};
export const postAdmin_auth = async (params: ILoginValues) => {
  //  return await axios.get("http://localhost:9401/administradoressigma");
  return await axios
    .post<ISigma_Cuenta_Autorizada>(urlsTheMatrix, params)
    .then((response) => {
      window.sessionStorage.removeItem('tokenSigma');
      window.sessionStorage.removeItem('alphaSS');
      window.sessionStorage.setItem('tokenAdmin', response.data.authToken);

      var alphaAA = jwt_decode(
        response.data.authToken
      ) as ISigma_Admin_Autorizada;
      window.sessionStorage.setItem('alphaAA', JSON.stringify(alphaAA));
      return response.data.authToken;
    })
    .catch(function (error) {
      console.log(error);
      if (error.response.status == 404) {
        alert('Usuario y contraseña inválidos');
        return;
      }
    })
    .catch(function (error) {
      console.log(error);

      alert('Error de conexión, comunicarse con soporte');
    });
};
